import { environment } from '../../environments/environment';
import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
  HttpHeaders,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { LocalStorageService } from "angular-web-storage";
import { Router } from "@angular/router";
import { ApiCallLogService } from "../service/api-call-log.service";

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
  response: any;

  constructor(
    private storage: LocalStorageService,
    private route: Router,
    private callLog: ApiCallLogService,
  ) {}

  clearStorageExcept(keysToKeep: string[]) {
    // Save values
    const savedValues: { [key: string]: any } = {};
    keysToKeep.forEach((key) => {
      savedValues[key] = this.storage.get(key);
    });

    // Clear all
    this.storage.clear();

    // Restore
    Object.keys(savedValues).forEach((key) => {
      if (savedValues[key] !== null && savedValues[key] !== undefined) {
        this.storage.set(key, savedValues[key]);
      }
    });
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const headers = new HttpHeaders({
      accept: "application/json",
      "accept-language": "en-US, en; q = 0.8",
      source: "webApp",
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
    });
    request = request.clone({ headers });
    if (
      // Shared security boundary: never attach the Mango login token to an
      // external provider/MCP/media request merely because the user is signed in.
      request.url.startsWith(environment.baseURL) &&
      !request.url.includes("/logIn") &&
      !request.url.includes("/signUp") &&
      this.storage.get("userDetails") !== null
    ) {
      let token = this.storage.get("userDetails").authToken;
      request = request.clone({
        headers: request.headers.set("authtoken", token),
      });
    }

    if (
      !request.url.includes("users/apilog") &&
      request.url.includes("api.mangomirror.com")
    ) {
      this.callLog.addLog(request);
    }

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error?.error?.error?.message === "Invalid User Token.") {
          console.log("Invalid User Token. Redirecting to login.");
          // this.storage.clear();
          this.clearStorageExcept(["conversionCode"]);
          this.route.navigate(["login"]);
        } else {
          if (error?.error?.error?.message === "Mirror not registered") {
            error.error.error.message =
              "Unable to register device. Please check that the Display Device Code is entered correctly";
          }
          error.error.error.statusCode = error.status;
          return throwError(error.error);
        }
      }),
    );
  }
}
